// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"456":"dc8e20ad","860":"dc8e20ad"}[chunkId] + ".chunk.css";
};